import { register as registerSwiper } from 'swiper/element/bundle';

export const registerSwiperElements = (
  customElementsRegistry: Pick<CustomElementRegistry, 'get'> | undefined = globalThis.customElements
): void => {
  // Avoid double registration and support non-browser runtimes.
  if (!customElementsRegistry || customElementsRegistry.get('swiper-container')) {
    return;
  }

  registerSwiper();
};
